"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BANNER_IMAGE = void 0;
const BANNER_IMAGE = exports.BANNER_IMAGE = 'banner-video';
